import { ActivityLogPanel } from '@/components/activity-log/ActivityLogPanel';

interface CompanyActivityTabProps {
  companyId: string;
}

export function CompanyActivityTab({ companyId }: CompanyActivityTabProps) {
  return (
    <div className="space-y-4">
      <ActivityLogPanel 
        entityType="company"
        entityId={companyId}
        title="Company Activity"
        showFilters={true}
        showEntityBadge={false}
        maxHeight="500px"
        limit={50}
      />
    </div>
  );
}
